module.exports = __webpack_public_path__ + "static/img/close.ba510d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/close.png
// module id = Py7c
// module chunks = 1